import TabFilters from './TabFilters';

export default TabFilters;



// WEBPACK FOOTER //
// ./scripts/blocks/TabFilters/index.js